
export async function uploadSingleOtherFile(file: File, authToken: string, customFileName?: string) {
  try {
    const { uploadFileURL } = (window as any).data.upload;
    const { gcpBaseURL } = (window as any).data.auth;

    const res = await fetch(`${gcpBaseURL}`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    const data = await res.json();
    const formData = new FormData();
    
    // Use custom filename if provided, otherwise use the original file name
    const finalFileName = customFileName || file.name;
    
    // The key change: specify the filename as the third parameter in formData.append()
    formData.append('file', file, finalFileName);

    const response = await fetch(uploadFileURL, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${data.gcp_token}`,
      },
      body: formData,
    });

    if (response.ok) {
      return true;
    } else {
      console.error(
        `Upload failed for file "${finalFileName}": ${response.status} ${response.statusText}`
      );
      return false;
    }
  } catch (error: any) {
    console.error(`Error uploading file "${customFileName || file.name}":`, error);
    return false;
  }
}
